import { useAppHookContext } from '@nkr/utils/rest-api';
import FollowUpNav from './nav';
import SurveyContainer from './survey/survey-container';
import FollowUpSurveyView from './survey/view';
import MarkComplete from './survey/mark-complete';
import Donors from './donor/list';
import FollowUpDonorAdd from './donor/add-edit/add';
import FollowUpDonorEdit from './donor/add-edit/edit';
import FollowUpReportsNav from './reports/nav';
import FollowUpComplianceReport from './reports/compliance';
import FollowUpReconciliationReport from './reports/reconciliation';
import DonorsNav from '../tabs';

interface IProps {
    activeKey: string,
    subKey: string,
    isAdmin: boolean,
    isAdminLogin: boolean,
    centerId: number,
    itemId: number
}

const FollowUpContainer = (props: IProps) => {
    const { app } = useAppHookContext();

    return (
        <div style={{ padding: 10, backgroundColor: 'white' }}>
            {props.isAdmin && (
                <DonorsNav
                    activeKey={'DONOR-FOLLOW-UP'}
                    centerId={props.centerId}
                    isMicrositeParticipant={true}
                    isAdmin={props.isAdmin}
                    isFollowUpParticipant={true}
                    isInDonorShield={false}
                    organType={app.site.organType}
                    onTabSelect={() => null}
                />
            )}

            {props.activeKey == 'SURVEYS' && (
                <>
                    <div style={{ padding: 5 }}>
                        <FollowUpNav
                            activeKey={props.activeKey}
                            isAdmin={props.isAdmin}
                            isAdminLogin={props.isAdminLogin}
                            centerId={props.centerId}
                        />

                        <SurveyContainer
                            centerId={props.centerId}
                            activeKey={props.subKey}
                            isAdmin={props.isAdmin}
                            isAdminLogin={props.isAdminLogin}
                        />
                    </div>
                </>
            )}

            {props.activeKey == 'SURVEY' && (
                <>
                    {props.subKey == 'VIEW' && (
                        <FollowUpSurveyView
                            id={props.itemId}
                            isAdmin={props.isAdmin}
                            isAdminLogin={props.isAdminLogin}
                        />
                    )}

                    {props.subKey == 'MARK-COMPLETE' && (
                        <MarkComplete surveyId={props.itemId} isAdmin={props.isAdmin} />
                    )}
                </>
            )}

            {props.activeKey == 'DONORS' && (
                <>
                    <div style={{ padding: 5 }}>
                        <FollowUpNav
                            activeKey={props.activeKey}
                            isAdmin={props.isAdmin}
                            isAdminLogin={props.isAdminLogin}
                            centerId={props.centerId}
                        />

                        <Donors
                            centerId={props.centerId}
                            activeKey={props.subKey}
                            isAdmin={props.isAdmin}
                            isAdminLogin={props.isAdminLogin}
                        />
                    </div>
                </>
            )}

            {props.activeKey == 'DONOR' && (
                <>
                    {props.subKey == 'ADD' && (
                        <FollowUpDonorAdd centerId={props.centerId} />
                    )}

                    {props.subKey == 'EDIT' && (
                        <FollowUpDonorEdit centerId={props.centerId} donorId={props.itemId} isAdminLogin={props.isAdminLogin} />
                    )}
                </>
            )}

            {props.activeKey == 'REPORTS' && (
                <>
                    <div style={{ padding: 5 }}>
                        <FollowUpNav
                            activeKey={props.activeKey}
                            isAdmin={props.isAdmin}
                            isAdminLogin={props.isAdminLogin}
                            centerId={props.centerId}
                        />

                        <div style={{ padding: 20 }}>
                            <FollowUpReportsNav
                                activeKey={props.subKey}
                                isAdmin={props.isAdmin}
                                isAdminLogin={props.isAdminLogin}
                                centerId={props.centerId}
                            />

                            {props.subKey == 'COMPLIANCE' && (
                                <FollowUpComplianceReport centerId={props.centerId} isAdmin={props.isAdmin} isAdminLogin={props.isAdmin} />
                            )}

                            {props.subKey == 'RECONCILIATION' && (
                                <FollowUpReconciliationReport centerId={props.centerId} isAdmin={props.isAdmin} isAdminLogin={props.isAdmin} />
                            )}
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}

export default FollowUpContainer;